import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { RHFTextField, RHFAutocomplete } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { Typography, createFilterOptions } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

export default function EmpCertNewEditForm({ certInstNmArr, certNmArr }) {
  const { control, setValue, watch, resetField, trigger } = useFormContext();
  const filter = createFilterOptions();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'empCert',
  });

  const handleAdd = () => {
    append({
      cerSrno: 0,
      certiNm: '',
      certiInstiNm: '',
      certfromDate: null,
      certtoDate: null,
    });
  };

  const handleRemove = (index) => {
    remove(index);
  };
  return (
    <>
      <Box
        mt={4}
        rowGap={3}
        columnGap={2}
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
        }}
        mb={3}
      >
        {/* <Typography variant="subtitle2" sx={{ mb: 3 }}>
          Certification Details:
        </Typography> */}
        <Box>
          <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
            Certification Details:
          </Typography>
        </Box>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-end', md: 'center' }}
          justifyContent="flex-end"
        >
          <Button
            size="small"
            color="primary"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={handleAdd}
            sx={{ flexShrink: 0, minWidth: '140px', justifyContent: 'flex-start' }}
          >
            Add Certificate
          </Button>
        </Stack>
      </Box>
      <Stack divider={<Divider sx={{ borderStyle: 'dashed' }} />} spacing={2}>
        {fields.map((item, index) => (
          <Stack key={item.id} spacing={1.5} sx={{
            p: 1,
            borderRadius: 1,
            bgcolor: item.fromCandidate ? 'grey.100' : 'transparent', 
            border: item.fromCandidate ? '0.5px dashed grey' : 'none',
          }} >
            <Typography variant="subtitle2" sx={{ color: 'primary', mb: 2 }}>
              Certificate {index + 1}:
            </Typography>
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
              <RHFTextField name={`empCert[${index}].cerSrno`} />
            </Box>
            <Box
              rowGap={1.5}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
            >
              {/* <RHFTextField name={`empCert[${index}].certiNm`} label={<div>Certification Name<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span></div>} /> */}
              <RHFAutocomplete
                name={`empCert[${index}].certiNm`}
                label={
                  <div>
                    Certification Name<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                  </div>
                }
                disableClearable
                options={certNmArr}
                showPlusIcon
                onChange={(event, newValue) => {
                  if (typeof newValue === 'string') {
                    setValue(`empCert[${index}].certiNm`, newValue);
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setValue(`empCert[${index}].certiNm`, newValue.inputValue);
                  } else {
                    setValue(`empCert[${index}].certiNm`, newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  // Suggest the creation of a new value
                  if (params.inputValue !== '') {
                    filtered.push(`${params.inputValue}`);
                  }

                  return filtered;
                }}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === 'string') {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option;
                }}
                // value={selectedCurLoc}
                // onChange={(event, newValue) => {
                //   setSelectedCurLoc(newValue);
                // }}
                renderOption={(props, option) => (
                  <li {...props} key={option}>
                    {option}
                  </li>
                )}
              />
              {/* <RHFTextField name={`empCert[${index}].certiInstiNm`} label="Institute Name" /> */}
              <RHFAutocomplete
                name={`empCert[${index}].certiInstiNm`}
                label="Institute Name"
                disableClearable
                options={certInstNmArr}
                showPlusIcon
                onChange={(event, newValue) => {
                  if (typeof newValue === 'string') {
                    setValue(`empCert[${index}].certiInstiNm`, newValue);
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setValue(`empCert[${index}].certiInstiNm`, newValue.inputValue);
                  } else {
                    setValue(`empCert[${index}].certiInstiNm`, newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  // Suggest the creation of a new value
                  if (params.inputValue !== '') {
                    filtered.push(`${params.inputValue}`);
                  }

                  return filtered;
                }}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === 'string') {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option;
                }}
                // value={selectedCurLoc}
                // onChange={(event, newValue) => {
                //   setSelectedCurLoc(newValue);
                // }}
                renderOption={(props, option) => (
                  <li {...props} key={option}>
                    {option}
                  </li>
                )}
              />
              <Controller
                name={`empCert[${index}].certfromDate`}
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <DatePicker
                    label="From Date"
                    value={field.value}
                    onChange={(newValue) => {
                      field.onChange(newValue);
                      trigger(`empCert[${index}].certfromDate`);
                      trigger(`empCert[${index}].certtoDate`);
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error: !!error,
                        helperText: error?.message,
                      },
                    }}
                    maxDate={new Date()}
                  />
                )}
              />
              <Controller
                name={`empCert[${index}].certtoDate`}
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <DatePicker
                    label="To Date"
                    value={field.value}
                    onChange={(newValue) => {
                      field.onChange(newValue);
                      trigger(`empCert[${index}].certtoDate`);
                      trigger(`empCert[${index}].certfromDate`);
                    }}
                    maxDate={new Date()}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error: !!error,
                        helperText: error?.message,
                      },
                    }}
                  />
                )}
              />
            </Box>

            <Stack
              direction={{ xs: 'column', md: 'row' }}
              alignItems={{ xs: 'flex-end', md: 'center' }}
              justifyContent="flex-end"
            >
              <Button
                size="small"
                color="error"
                startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                onClick={() => handleRemove(index)}
              >
                Remove
              </Button>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </>
  );
}
EmpCertNewEditForm.propTypes = {
  certNmArr: PropTypes.array,
  certInstNmArr: PropTypes.array,
};
